<div class="row">
    @for (highlight of highlightsArray; track highlight; let ind = $index) {
    <div class="col-12 col-sm-6 col-md-4 h-100 pr-1 pl-1">
        <div class="card clickable h-100" [routerLink]="['../../machine',chassisnr,'highlights']"
            [state]="{ position: ind}">
            <img class="card-img-top" src="{{ 'https://www.poettinger.at' + highlight.HEADERIMAGE}}"
                alt="{{highlight.BEZEICHNUNG}}">
            <div class="card-body">
                <div class="row card-title">
                    <div class="col">
                        {{highlight.BEZEICHNUNG}}
                        <em class="far fa-chevron-right icon"></em>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
</div>